module.exports = __webpack_public_path__ + "img/payment_cart.088c671.png";